import { render, staticRenderFns } from "./CommonCollapse3.vue?vue&type=template&id=53afa792&scoped=true&"
import script from "./CommonCollapse3.vue?vue&type=script&lang=js&"
export * from "./CommonCollapse3.vue?vue&type=script&lang=js&"
import style0 from "./CommonCollapse3.vue?vue&type=style&index=0&id=53afa792&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53afa792",
  null
  
)

export default component.exports